import {uiHeatmapPalette} from "../../constants/uiTokens"

/** About one third of the original 500m cell side; the API may coarsen very large selections. */
export const HEATMAP_CELL_SIZE_METERS = 170

/** Keep legend and map in sync, including samples with fewer than five distinct quantiles. */
export const getHeatmapColor = (index: number, binCount: number): string => {
    const position = binCount <= 1 ? 0.5 : Math.max(0, Math.min(index / (binCount - 1), 1))
    return uiHeatmapPalette[Math.round(position * (uiHeatmapPalette.length - 1))]
}
